module.exports = __webpack_public_path__ + "static/media/3.806fc1d2.svg";